import api from '@/api/';
import tips from '@/components/tips/main';
import qs from "qs"
import router from '@/router';
import instantiationPromise from "@/library/promiseTool";
let authorizeWeiXin = {
  doAuth() {
    let redirectOauthUrl = window.location.protocol + "//h5.mgzf.com" + `${window.location.pathname}${window.location.search}`;  // 转换过后的redirectUrl
    // 获取对应环境appId, 并去授权页面
    api.authorize.loadAppIdConfig()
      .then(({ data }) => {
        if (data.code == 10000) {
          location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${data.content}&redirect_uri=${window.encodeURIComponent(redirectOauthUrl)}&response_type=code&scope=snsapi_userinfo&state=${window.encodeURIComponent(window.location.origin)}`
        }
      }).catch(err => {
        tips('获取appid失败!')
      })
  },

  doCode() {
    let tempQuery = qs.parse(window.location.href.split('?')[1]);
    let code = tempQuery.code;
    delete tempQuery.code;
    var querystring = qs.stringify(tempQuery);
    if (querystring) {
      window.history.replaceState({}, "", `${location.origin}${location.pathname}?` + querystring);
    } else {
      window.history.replaceState({}, "", `${location.origin}${location.pathname}`);
    }
    let {resolve:_resolveTemp ,reject:_rejectTemp, promise:promiseTemp} = instantiationPromise ();

    api.authorize.authWeChatCallBackPage({
      bindType: 1,
      code
    })
      .then(({ data: { code, content, message } }) => {
        if (content && content.openId) {
          window.localStorage.setItem('mogo_openid', content.openId)
        }
        if (code == 10000) {
          if (window.localStorage.getItem('mogo_logout') == 'true') {
            router.replace(`/login?redirectUri=${window.encodeURIComponent(location.href)}&openId=${content.openId}`);
            window.localStorage.removeItem("mogo_logout");
            return
          }
          var auth = {
            userId: content.renterId,
            mobile: content.mobile,
            token: content.token
          }
          _resolveTemp(auth)
        } else if (code == 20003) {
          router.replace(`/login?redirectUri=${window.encodeURIComponent(location.href)}&openId=${content.openId}`);
        } else {
          _rejectTemp(message)
          this.$tips(message)
        }
      })
      .catch(err => {
        _rejectTemp('授权失败!')
        tips('授权失败')
      })
    return promiseTemp

  }
}
export default authorizeWeiXin;



// WEBPACK FOOTER //
// ./src/store/modules/authorizeHelper/authorizeWeiXin.js